import * as React from 'react';
import { RankItem } from '@/fetch.ts';
import defaultAvatar from '@images/web/default.png';
import './index.scss';
interface Props extends RankItem {
  width: number,
  rich?: boolean,
  small?: boolean,
  jump?: boolean,
}
const AnchorItem: React.FC<Props> = props => (
  <div
    style={
      {
        width: props.width + 'px',
        height: props.rich ? '82px' : '62px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundSize: '332px 82px',
        paddingTop: '0px',
      }
    }
  >
    <i
      className={`web-rank-no-${props.iRank > 3 ? 'n' : props.iRank} web-rank-no`}
    >
      {
        props.iRank
      }
    </i>
    <div
      style={
        {
          width: '170px',
          display: 'flex',
          alignItems: 'center',
          marginLeft: '35px',
        }
      }
    >
      <div
        style={
          {
            position: 'relative',
            width: props.rich ? '62px' : '42px',
            height: props.rich ? '62px' : '42px',
            borderRadius: '50%',
            marginRight: '8px',
          }
        }
      >
        <img
          style={
            {
              width: props.rich ? '60px' : '40px',
              height: props.rich ? '60px' : '40px',
              borderRadius: '50%',
              border: '1px solid black',
              cursor: props.rich || (props.small && !props.jump) ? 'default' : 'pointer',
            }
          }
          title={props.sNickName}
          src={props.sLogoUrl}
          onError={(event: any): void => {
            event.target.onerror = null;
            event.target.src = defaultAvatar;
          }}
          onClick={(): void => {
            if (props.rich || (props.small && !props.jump)) return;
            window.open('https://m.huya.com/' + props.tJump.iRoomId, '_blank');
          }}
        />
        {
          props.tJump.iLive !== 0 && !props.rich && !(props.small && !props.jump) &&
          <i
            className='web-living'
          ></i>
        }
      </div>
      <p
        style={
          {
            width: '120px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            margin: '0px',
            fontSize: '14px',
            color: '#d6b379',
            textAlign: 'left',
            cursor: props.rich || (props.small && !props.jump) ? 'default' : 'pointer',
          }
        }
        onClick={(): void => {
          if (props.rich || (props.small && !props.jump)) return;
          window.open('https://m.huya.com/' + props.tJump.iRoomId, '_blank');
        }}
      >
        {props.sNickName}
      </p>
    </div>
    <p
      style={
        {
          width: '80px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          margin: '0px',
          fontSize: '14px',
          color: '#d6b379',
          textAlign: 'right',
        }
      }
    >{props.lScore}</p>
  </div>
)
export default AnchorItem;